module.exports = __webpack_public_path__ + "static/media/analiseDiscurso.03b61ff0.md";